export function getCurrentUrlWithAdditonalParam(key: string, value: string) {
  const currentSearchParams = new URLSearchParams(window.location.search);
  currentSearchParams.set(key, value);

  const searchParamsStr = currentSearchParams.toString();
  return `${window.location.pathname}${
    searchParamsStr ? `?${currentSearchParams.toString()}` : ''
  }`;
}
